import React, { useEffect, useState } from 'react';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import { DisplayS, HeadingSBold, BodyS } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import styles from 'assets/jss/material-dashboard-pro-react/views/numberDetails/boostYourPlanStyle';
import { makeStyles } from '@material-ui/core/styles';
import Button from 'components/CustomButtons/Button';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import FBBDialog from 'components/TryAndBuy/FBBDialog';
import { SingleCustomerProduct } from 'utils/api/models/products/singleCustomerProduct';
import { useLocation } from 'react-router';

type dialogType = 'boostYourPlan';

// @ts-ignore
const useStyles = makeStyles(styles);

const useQuery = () => {
	return new URLSearchParams(useLocation().search);
};

export interface IBoostPlanCard {
	tariffPlan?: SingleCustomerProduct;
	phoneNumber: string;
	reload: () => void;
	tryAndBuyDuration?: number;
	tryAndBuyCatalogEntryView: types.ecommerce.CatalogEntryView | undefined;
}

const BoostPlanCard = ({
	tariffPlan,
	phoneNumber,
	reload,
	tryAndBuyDuration = 0,
	tryAndBuyCatalogEntryView,
}: IBoostPlanCard) => {
	const classes = useStyles();
	const [isFBBDialogOpen, setIsFBBDialogOpen] = useState<boolean>(false);
	const query = useQuery();
	const openDialog = query.get('open') as dialogType;

	const onClick = () => {
		setIsFBBDialogOpen(true);
	};

	useEffect(() => {
		if (openDialog === 'boostYourPlan') {
			setIsFBBDialogOpen(true);
		}
	}, [openDialog]);

	return (
		<ConditionalRender
			show={!!tariffPlan && !!tryAndBuyCatalogEntryView}
			onTrue={() => (
				<>
					<GridItem xs={12} md={6}>
						<Card className={classes.card}>
							<CardBody className={classes.cardBody}>
								<div>
									<HeadingSBold color="primary-dark">
										{translate('numbers.details.boost.your.plan')}
									</HeadingSBold>
									<DisplayS color="primary-dark">{tryAndBuyCatalogEntryView?.name}</DisplayS>
									<BodyS color="secondary-dark">
										{translate(
											tryAndBuyDuration === 1
												? 'numbers.details.boost.plan.one.month'
												: 'numbers.details.boost.plan.number.of.months',
											tryAndBuyDuration
										)}
									</BodyS>
								</div>
								<div className={classes.buttonWrapper}>
									<Button color="primary-dark" onClick={onClick}>
										{translate('numbers.details.boost.your.plan.button')}
									</Button>
								</div>
							</CardBody>
						</Card>
					</GridItem>
					<FBBDialog
						hideDialog={() => setIsFBBDialogOpen(false)}
						isOpen={isFBBDialogOpen}
						header={translate('tryandbuy.fbb.serviceName')}
						selectedAccount={{
							accountNum: phoneNumber,
							tryAndBuyProduct: tryAndBuyCatalogEntryView!,
							currentTariffPlan: tariffPlan!,
						}}
						reload={reload}
					/>
				</>
			)}
		/>
	);
};

export default BoostPlanCard;
